import { gql } from '@apollo/client';

export const SAVE_DOCUMENT_STATE_TRANSITION = gql`
  mutation saveDocumentStateTransition($documentStateTransition: SaveStateTransitionInput!) {
    saveDocumentStateTransition(documentStateTransition: $documentStateTransition) {
      commandId
    }
  }
`;
